import { render, staticRenderFns } from "./VCardActions.vue?vue&type=template&id=011fd810&lang=pug&functional=true&"
import script from "./VCardActions.vue?vue&type=script&lang=js&"
export * from "./VCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports